export default {
    streamNoteListedWebpages:
        'Обратите внимание, что перечисленные веб-страницы не являются собственностью Netvork LLP.',
    streamNoteAdministrationCompliance:
        'За их администрирование и соблюдение действующего законодательства их владельцами Netvork LLP ответственности не несет.',
    streamNoteReportEmail:
        'Если у вас возникли проблемы с целевыми страницами, пожалуйста, сообщите о них на',
    respectfullyTeam: 'С уважением, команда Netvork',
    enterMessengerAccount: 'Введите аккаунт мессенджера',
    invalidTelegram: 'Неверный адрес Telegram',
    invalidSkype: 'Неверный адрес Skype/Teams',
};
